import { useEffect, useState } from 'react'
import { IContactPhone } from '../../../../types/contact';

import { Input, Table } from 'reactstrap';
import { CancelIcon, CheckMarkIcon, EditIcon } from '../../../common/icons';
import { CheckGroup } from '../../../../hook/useCheckGroup';
import useToggle from '../../../../hook/useToggle';
import PhoneUpdate from './phone-update';
import { GET_POSITION_CONTACT_PHONES, SET_POSITION_PRIMARY_PHONE } from '../../../../graphql/contact-gql';
import { useLazyQuery, useMutation } from '@apollo/client';
import { notifySuccess } from '../../../../services/notification';
import { IPosition } from '../../../../types/position';
import SpinnerOverlay from '../../../common/spinner/spinner';
import ImgButton from '../../../common/img-button/img-button';
import useAuth from '../../../../hook/useAuth';

type PositionPhoneProps = {
    position: IPosition;
    checkGroup: CheckGroup<number>;
}

const PositionPhone = (props: PositionPhoneProps) => {
    const {position, checkGroup} = props;
    const { isFrenchTranslator } = useAuth()
    const [contactPhone, setContactPhone] = useState<IContactPhone>()
    const {isOpen: editPhoneOpen, toggle: toogleEditPhone} = useToggle()
    const [cloned,setCloned] = useState<boolean>(false);

    const [getPositionPhones, {loading, data}] = useLazyQuery(GET_POSITION_CONTACT_PHONES, {
        onCompleted: (data) => {
            if (data?.position?.contactPhones) {
                checkGroup.init(data.position.contactPhones.map((e: IContactPhone) => e.id))
            }
        }
    })

    const [setPrimaryPhone, {loading: loadingPrimary}] = useMutation(SET_POSITION_PRIMARY_PHONE)

    useEffect(() => {
        setCloned(!!position?.shareLinkId)
        if (position) {
            getPositionPhones({variables: {positionId: position.positionId}})
        }
    }, [position])

    const editContactPhone = (contactPhone: IContactPhone) => {
        setContactPhone(contactPhone)
        toogleEditPhone()
    }

    const setPrimary = (contactPhone: IContactPhone) => {
        setPrimaryPhone({
            variables: {
                positionId: contactPhone.businessEntityId,
                contactPhoneId: contactPhone.id
            },
            refetchQueries: [{
                query: GET_POSITION_CONTACT_PHONES,
                variables: { positionId: contactPhone?.businessEntityId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => data && notifySuccess()
        })
    }

    const visibleColumnsCount = () : number => {
        // french translator won't see the select or edit columns
        return isFrenchTranslator ? 5 : 7;
    }

    return (
        <>
            {(loading || loadingPrimary) && <SpinnerOverlay />}

            {data?.position?.contactPhones && (
            <Table striped id="position_phone_numbers" className="fixed">
                <thead>
                    <tr>
                        {!isFrenchTranslator && <th className="icon-column">
                            <span className="sr-only">select phone</span>
                            {data?.position?.contactPhones?.length > 0 && !checkGroup.isEmpty() &&
                                <>
                                    <span id="posPhoneSelectAllLbl" className="sr-only">Select all</span>
                                    <Input
                                        type="checkbox"
                                        title="Select all"
                                        aria-labelledby="posPhoneSelectAllLbl"
                                        checked={checkGroup.isAllChecked()}
                                        onChange={checkGroup.onCheckAll}
                                        disabled={cloned}
                                    />
                                </>
                            }
                        </th>
                        }
                        <th>Phone Type</th>
                        <th>Country Code</th>
                        <th>10-Digit Number</th>
                        <th>Extension</th>
                        <th className="primary-mailing-column">Primary</th>
                        {!isFrenchTranslator && <th className="edit-column">Edit</th>}
                    </tr>
                </thead>
                <tbody>
                {
                    data?.position?.contactPhones?.length === 0
                    ?
                    <tr><td colSpan={visibleColumnsCount()} style={{textAlign: 'center'}}>No {position.isRole ? 'role' : 'position'} contact phones found.</td></tr>
                    :
                    data?.position?.contactPhones?.map((contactPhone: IContactPhone, index: number) => {
                        return (
                            <tr key={contactPhone.id}>
                                {!isFrenchTranslator && <td>
                                    <Input type="checkbox"
                                        aria-label={'Select phone ' + contactPhone.areaCode + contactPhone.localNumber}
                                        checked={checkGroup.isChecked(contactPhone.id)}
                                        onChange={event => checkGroup.onCheck(event, contactPhone.id)}
                                        disabled={cloned}
                                    />
                                </td>
                                }
                                <td>{contactPhone.phoneType.label}</td>
                                <td>{contactPhone.countryCode}</td>
                                <td>{contactPhone.areaCode + '-' + contactPhone.localNumber.substring(0,3) + '-' + contactPhone.localNumber.substring(3)}</td>
                                <td>{contactPhone.extension? contactPhone.extension : ""}</td>
                                {!isFrenchTranslator && <td>
                                    {contactPhone.assignType?.code === "PRIMARY"
                                        ? <CheckMarkIcon></CheckMarkIcon>
                                        : <Input type="checkbox"
                                            aria-label="Set primary phone"
                                            checked={contactPhone.assignType?.code === "PRIMARY"}
                                            onChange={()=>setPrimary(contactPhone)}
                                            disabled={cloned}/>
                                    }
                                </td>}
                                {isFrenchTranslator && <td>
                                    {contactPhone.assignType?.code === "PRIMARY"
                                        ? <CheckMarkIcon></CheckMarkIcon>
                                        : <CancelIcon></CancelIcon>
                                    }
                                </td>}
                                {!isFrenchTranslator && <td>
                                    <ImgButton className="float-end" aria-label="Edit phone" title="Edit phone" onClick={()=>editContactPhone(contactPhone)} disabled={cloned}>
                                        <EditIcon className="edit-pencil"/>
                                    </ImgButton>
                                </td>
                                }
                            </tr>
                        )
                    })
                }
                </tbody>
            </Table>
            )}

            <PhoneUpdate contactPhone={contactPhone} isRole={position?.isRole} isOpen={editPhoneOpen} toggle={toogleEditPhone}></PhoneUpdate>
        </>
    )
}

export default PositionPhone;
